export enum Size {
  // 10x10
  TINY = 'tiny',
  // 16x16
  SMALL = 'small',
  // 20x20
  MEDIUM = 'medium',
  // 32x32
  LARGE = 'large',
  // 40x40
  XLARGE = 'xlarge'
}
